<div class="pw-button">
    <button class="pw-button__button" [disabled]="data.disabled" (click)="click($event)">
      {{data.label}}
    </button>
  </div>